import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

import styled from "styled-components/macro";

import { faSyncAlt } from "@fortawesome/pro-solid-svg-icons";

import { formatNumberWithCommas } from "Utilities/Number";

export default function PledgeUser({
  ID: pledgeID,
  householdName,
  householdID,
  headOfHouseholdUserID,
  totalPledged,
  amountGiven,
  intervalDescription,
  amountPerInterval = 0,
  status,
  hasRecurringGift,
}) {
  let progressWidth = 0;
  let borderWidth = 0;

  totalPledged = totalPledged * 1;
  amountGiven = amountGiven * 1;

  if (amountGiven < totalPledged) {
    progressWidth = amountGiven / totalPledged;
    borderWidth = 100;
  } else {
    progressWidth = 1;
    borderWidth = (totalPledged / amountGiven) * 100;
  }

  const amountPerIntervalRounded = Number(amountPerInterval).toFixed(0);
  const amountGivenRounded = Number(amountGiven).toFixed(0);

  const navigateToProfile = () => {
    localStorage.setItem("setPledgeDetailID", pledgeID);
    if (headOfHouseholdUserID)
      window.fnReactBus.loadUserGivingProfile(headOfHouseholdUserID);
    else window.fnReactBus.loadHouseholdGivingProfile(householdID);
  };

  return (
    <Wrapper onClick={navigateToProfile}>
      <HouseholdName
        className={
          headOfHouseholdUserID
            ? "can_mini_profile can_mini_profile_" + headOfHouseholdUserID
            : ""
        }
        data-userid={headOfHouseholdUserID}
      >
        {householdName}
      </HouseholdName>
      {hasRecurringGift ? (
        <TooltipWrapper>
          <Icon
            color="#586b74"
            icon={faSyncAlt}
            size="xs"
            style={{ marginRight: "10px" }}
          />
          <Tooltip>
            This pledge has recurring payment associated with it.
          </Tooltip>
        </TooltipWrapper>
      ) : null}
      <Amount>
        {status === "closed" ? (
          <>
            <i className="fad fa-octagon fa-swap-opacity" /> $
            {formatNumberWithCommas(amountGivenRounded)}
          </>
        ) : (
          <>
            {status === "fulfilled" && <i className="fas fa-check" />} $
            {formatNumberWithCommas(amountPerIntervalRounded)}
            {intervalDescription !== "Once" && (
              <Description>/{intervalDescription.toLowerCase()}</Description>
            )}
          </>
        )}
      </Amount>

      <ProgressBarContainer>
        <ProgressBarBorder
          style={
            status === "closed"
              ? { background: "#BEC3C7", width: borderWidth + "%" }
              : { width: borderWidth + "%" }
          }
        />
        <ProgressBar
          style={{ width: "calc((100% - 4px) * " + progressWidth + ")" }}
        />
      </ProgressBarContainer>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  padding: 6px 12px;
  cursor: pointer;
  display: flex;
  flex-wrap: wrap;
  align-items: center;

  &:nth-child(odd) {
    background: rgba(0, 0, 0, 0.05);
  }
`;

const HouseholdName = styled.div`
  font-weight: 400;
  margin-right: auto;
`;

const Amount = styled.div`
  font-weight: 400;
  color: #586b74;
  & i {
    font-size: 13px;
    transform: translateY(-1px);
  }
`;
const Description = styled.span`
  font-weight: 300;
`;

const ProgressBarContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  margin-top: 4px;
  width: 100%;
`;
const ProgressBarBorder = styled.div`
  border: 1px solid #828c8d;
  border-radius: 20px;
  padding: 1px;
  box-sizing: border-box;
  height: 12px;
  width: 100%;
`;
const ProgressBar = styled.div`
  height: 8px;
  background: red;
  border-radius: 8px;
  background: var(--fundColor);
  position: absolute;
  left: 2px;
`;
const TooltipWrapper = styled.div`
  position: relative;
`;
const Icon = styled(FontAwesomeIcon)``;

const Tooltip = styled.div`
  opacity: 0;
  position: absolute;
  top: 0;
  right: 120%;
  display: flex;
  justify-content: center;
  padding: 8px;
  width: 150px;
  border: none;
  color: #15436a;
  pointer-events: none;
  transition: opacity 0.3s ease;
  z-index: 1;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: 5px;
    background: hsla(180 9% 100% / 0.8);
    backdrop-filter: blur(3px);
    -webkit-backdrop-filter: blur(3px);
    z-index: -1;
  }

  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: 5px;
    box-shadow: 0 2px 5px hsl(199 14% 40% / 0.25);
    z-index: 1;
  }

  &:hover {
    opacity: 1;
  }

  ${TooltipWrapper}:hover & {
    opacity: 1;
  }
`;
